//import * as types from './types';
import { BookingSettingsService } from '../../services/booking-settings.service';
import { HttpClient, JSON_STRING, createHttpGetOptions } from '../../../../services/http/http-client';
import { MODIFICATION_URL, SETTINGS_URL } from '../../../../services/common-urls';
import { localDetailsExternalTable } from '../../models/local-details.mode';
import { wait } from '../../../../utility';
import { HttpLib } from '../../../../services/http/http-lib';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { objOf } from 'ramda';
import { omit } from 'ramda';
import { taskService } from '../../../tasks/services/tasks.service';
import * as types from '../../store/types'


let invoiceGroupItemsSource;

const fetchLocalDetailsSettings = async (commit, getters) => {
  const bookingLocalDetailsSettings = await BookingSettingsService.findLocalDetailsSettingsVal();

  commit(types.BookingSettingsData.SET.ALL, {
    ...getters.bookingSettingsData,
    ...bookingLocalDetailsSettings.data
  });
}
const fetchMoneyDetailsSettings = async (commit, getters) => {
  const moneyDetailsSettings = await BookingSettingsService.findMoneyDetailsSettings();

  commit(types.BookingSettingsData.SET.ALL, {
    ...getters.bookingSettingsData,
    ...moneyDetailsSettings.data
  });
}

const fetchInvoiceGroupItems = async (group_name, commit, getters) => {
  const invoiceGroupItems = await BookingSettingsService.findInvoiceGroupDetails({
    group_name
  });
  commit(types.BookingSettingsData.SET.ALL, {
    ...getters.bookingSettingsData,
    ...invoiceGroupItems.data
  });
}


export const bookingSettingsActions = {
  async [types.BookingSettingsData.FETCH.ALL]({ commit, getters }, payload) {
    const bookingSettingsData = await Promise.all([
      BookingSettingsService.findBookingSettings(),
      BookingSettingsService.findBookingSettingsTab(),
      BookingSettingsService.findRequestSettingsData(),
      BookingSettingsService.findLocalDetailsSettings(),
      BookingSettingsService.findLocalDetailsSettingsVal(),
      BookingSettingsService.findMoneyDetailsSettings(),
      BookingSettingsService.findAccountingSettingsInvoiceItems(),
      BookingSettingsService.findSharingData(),
      //BookingSettingsService.findBookingTaskSettingsVal(),
      taskService.taskTemplateGroup('booking')
    ]);

    const data = bookingSettingsData.reduce((accm, cur) => {
      accm = {
        ...accm,
        ...cur.data
      };
      return accm;
    }, {});

    console.log("POPOPO:::",data)

    const newArtists = [
      { artist_id: 0, artist_name: "All Artists" },
      ...data.artists
    ];

    commit(types.BookingSettingsData.SET.ALL, {
      ...data,
      artists: newArtists
    });

    commit(types.RssList.SET.ALL, newArtists.map(e => {
      return {
        artist_id: e.artist_id
      };
    })
    );
    // commit(types.BookingSettingsData.SET.ALL, data);
  },
  async [types.UpdateBookingStatus]({ commit, getters }, payload) {
    const { name, value, booking_status_id } = payload;
    console.log(payload);
    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      statuses: getters.bookingSettingsData.statuses.map(stat => {
        if (stat['booking_status_id'] == booking_status_id) {
          return {
            ...stat,
            [name]: value
          };
        } else {
          return stat;
        }
      })
    });

    const updatedData = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'booking_status',
      kVal: booking_status_id,
      [name]: value
    });

    console.log(updatedData.data);

  },
  async [types.SaveBookingStatus]({ commit, getters }, payload) {
    const {
      booking_status_id,
      booking_status_name,
      booking_status_colour,
      publish_to_artist_flag,
      publish_to_website_flag,
      default_status_booking_flag,
      hide_free_on_date_flag,
      cancelled_flag
     } = payload;

    console.log(payload);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      statuses: getters.bookingSettingsData.statuses.map(stat => {
        if (stat['booking_status_id'] == booking_status_id) {
          return {
            ...stat,
            booking_status_name,
            booking_status_colour,
          };
        } else {
          return stat;
        }
      })
    });

    const updatedBookingStatus = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'save_booking_status',
      booking_status_id,
      booking_status_name,
      booking_status_colour,
      publish_to_artist_flag,
      publish_to_website_flag,
      default_status_booking_flag,
      hide_free_on_date_flag,
      cancelled_flag,
      output: JSON_STRING
    });
    // console.log(updatedBookingStatus.data);
  },
  async [types.CreateBookingStatus]({ commit, getters }, payload) {
    const {
      booking_status_name,
      booking_status_colour,
      publish_to_artist_flag,
      publish_to_website_flag,
      default_status_booking_flag,
      hide_free_on_date_flag,
      cancelled_flag
     } = payload;

    const bookingStatuses = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_booking_status',
      booking_status_name,
      booking_status_colour,
      publish_to_artist_flag,
      publish_to_website_flag,
      default_status_booking_flag,
      hide_free_on_date_flag,
      cancelled_flag,
      output: JSON_STRING,
    });

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      statuses: bookingStatuses.data.statuses,
    });
  },
  async [types.RemoveBookingStatus]({ commit, getters }, payload) {
    const booking_status_id = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      statuses: getters.bookingSettingsData.statuses.
        filter(stat => stat['booking_status_id'] != booking_status_id)
    });

    const deletedStatus = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'remove_booking_status',
      booking_status_id
    });
  },
  async [types.TravelOption.INSERT.SINGLE]({ commit, getters }, payload) {
    console.log(payload);

    const { travel_option_text } = payload;

    const newTravelOption = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_travel_option',
      travel_option_text,
      output: JSON_STRING,
    });

    // console.log(newTravelOption.data);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      travel_options: newTravelOption.data.travel_options,
    });
  },
  async [types.TravelOption.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { travel_option_text,
      travel_option_id } = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      travel_options: getters.bookingSettingsData.travel_options.map(op => {
        if (op['travel_option_id'] == travel_option_id) {
          return {
            ...op,
            travel_option_text
          };
        } else {
          return op;
        }
      }),
    });

    const updatedTravelOptin = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_travel_option',
      travel_option_id,
      travel_option_text,
      output: JSON_STRING,
    });
  },
  async [types.TravelOption.DELETE.SINGLE]({ commit, getters }, payload) {
    console.log(payload);
    const { travel_option_id } = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      travel_options: getters.bookingSettingsData.travel_options.
        filter(op => op['travel_option_id'] != travel_option_id),
    });

    const deletedTravelOption = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'delete_travel_option',
      travel_option_id
    });
  },
  async [types.UpdateConf]({ commit }, payload) {
    commit(types.UpdateConf, payload)
  },
  async [types.SaveConf]({ getters }) {
    console.log({ "getters.bookingSettingsData.conf": getters.bookingSettingsData.conf });
    const savedConf = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'save_request_settings',
      data: JSON.stringify(getters.bookingSettingsData.conf),
    });
  },
  async [types.UpdateCustomField]({ commit, getters }, payload) {
    console.log(payload, getters.bookingSettingsData);

    const { kVal, name, value, field_data, conf_field } = payload;

    const oldFieldLabel = getters.bookingSettingsData[field_data].find(cf => {
      if (cf['custom_field_id'] === kVal) {
        return true;
      } else {
        return false;
      }
    })?.field_label;

    console.log({ "oldFieldLabel": oldFieldLabel });

    const newConf = {
      ...getters.bookingSettingsData.conf,
      [conf_field]: omit([oldFieldLabel], {
        ...getters.bookingSettingsData.conf?.[conf_field],
        [value]: getters.bookingSettingsData?.conf?.[conf_field]?.[oldFieldLabel],
      })
    }

    console.log({ "getters.bookingSettingsData?.conf?.[conf_field]?.[oldFieldLabel]": getters.bookingSettingsData?.conf?.[conf_field]?.[oldFieldLabel] });

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      [field_data]: getters.bookingSettingsData[field_data].map(cf => {
        if (cf['custom_field_id'] === kVal) {
          return {
            ...cf,
            [name]: value
          };
        } else {
          return cf;
        }
      }),
      conf: newConf
    });

    const updatedCustomField = await HttpClient.post(MODIFICATION_URL, {
      table: 'custom_fields',
      modify_type: '',
      json_op: '',
      json_key: '',
      kVal,
      name,
      value,
    })
  },
  async [types.AddCustomField]({ commit, getters }, payload) {
    console.log(payload);
    const { field_label, external_table } = payload;

    const newCustomField = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_custom_field',
      field_label,
      external_table,
    });

    const loadedActions = {
      'contacts': 'load_contact_settings',
      'promoters': 'load_promoter_settings',
      'calendar_dates': 'load_event_settings',
      'booking_locations': 'load_location_settings',
      'calendar_date_artists': 'load_artist_settings',
    }[external_table];

    const loadedFields = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: loadedActions,
      output: JSON_STRING,
    });

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      ...loadedFields.data
    });

    console.log(loadedFields.data);
  },
  async [types.DeleteCustomField]({ commit, getters }, payload) {
    const { custom_field_id, conf_key, conf_field, field_label } = payload;
    // console.log({ "omit([field_label], getters.bookingSettingsData.conf?.[conf_field])": omit([field_label], getters.bookingSettingsData.conf?.[conf_field]) });
    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      [conf_key]: getters.bookingSettingsData[conf_key].filter(f => f.custom_field_id != custom_field_id),
      conf: {
        ...getters.bookingSettingsData.conf,
        [conf_field]: omit([field_label], getters.bookingSettingsData.conf?.[conf_field])
      }
    });
    
    // console.log(payload, getters.bookingSettingsData);
    const deletedCustomField = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'delete_custom_field',
      custom_field_id
    });
  },
  async [types.LocalDetailsType.UPDATE.SINGLE]({ commit, getters }, payload) {
    console.log(payload);

    const { item, value, name } = payload;

    const { local_details_type_id } = item;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      booking_localdetail_settings: getters.bookingSettingsData.booking_localdetail_settings.map(ld => {
        if (ld.local_details_type_id == local_details_type_id) {
          return {
            ...ld,
            [name]: value
          };
        } else {
          return ld;
        }
      })
    });

    const updatedLocalDetailsType = await HttpClient.post(MODIFICATION_URL, {
      kVal: local_details_type_id,
      name,
      value,
      table: 'local_details_types',
      modify_type: '',
      json_op: '',
      json_key: '',
    });
  },
  async [types.LocalDetailsTypeField.INSERT.SINGLE]({ commit, getters }, payload) {
    const { local_details_type_id, field_label } = payload;

    console.log(payload);

    const external_table = localDetailsExternalTable(local_details_type_id);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      [external_table]: [
        ...getters.bookingSettingsData?.[external_table],
        {
          field_label,
        }
      ]
    });

    const newLocalDetailsField = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_custom_field',
      field_label,
      external_table,
    });

    await fetchLocalDetailsSettings(commit, getters);

    // const bookingLocalDetailsSettings = await BookingSettingsService.findLocalDetailsSettingsVal();

    // commit(types.BookingSettingsData.SET.ALL, {
    //   ...getters.bookingSettingsData,
    //   ...bookingLocalDetailsSettings.data
    // });
  },
  async [types.LocalDetailsTypeField.UPDATE.SINGLE]({ commit, getters }, payload) {

    const { name, value, item } = payload;

    const { custom_field_id, external_table } = item;

    console.log({ name, value, custom_field_id, external_table, item });

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      [external_table]: getters.bookingSettingsData[external_table].map(ld => {
        if (ld['custom_field_id'] == custom_field_id) {
          return {
            ...ld,
            [name]: value
          };
        } else {
          return ld;
        }
      })
    })

    const updatedLocalDetailsCustomField = await HttpClient.post(MODIFICATION_URL, {
      kVal: custom_field_id,
      name,
      value,
      table: 'custom_fields',
      modify_type: '',
      json_op: '',
      json_key: '',
    });
  },
  async [types.LocalDetailsTypeField.DELETE.SINGLE]({ commit, getters }, payload) {

    const { custom_field_id, external_table } = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      [external_table]: getters.bookingSettingsData?.[external_table].filter(f => {
        if (f.custom_field_id == custom_field_id) {
          return false;
        } else {
          return true;
        }
      })
    });

    const deletedCustomField = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'remove_local_details_type_custom_field',
      custom_field_id
    });
  },
  async [types.LocalDetailsType.INSERT.SINGLE]({ commit, getters }, payload) {
    // console.log(payload);

    const { local_details_type_name, sequence } = payload;

    const newLocalDetailsType = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_local_details_type_name',
      local_details_type_name,
      sequence,
    });

    await fetchLocalDetailsSettings(commit, getters);
  },
  async [types.LocalDetailsType.DELETE.SINGLE]({ commit, getters }, payload) {

    const { local_details_type_id } = payload;

    const deletedLocalDetailsType = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'remove_local_details_type_name',
      local_details_type_id
    });


    await fetchLocalDetailsSettings(commit, getters);
  },
  async [types.InvoiceItem.INSERT.SINGLE]({ commit, getters }, payload) {
    const newInvoiceItem = HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_invoice_item',
      ...payload,
    });

    await wait(1000);

    await fetchMoneyDetailsSettings(commit, getters);
  },
  async [types.InvoiceItem.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { invoice_item_id } = payload;
    if (!invoice_item_id) {
      throw Error('Provide a valid Invoice Item ID');
    }
    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_items: getters.bookingSettingsData.invoice_items.map(invoice => {
        if (invoice.invoice_item_id == invoice_item_id) {
          return {
            ...invoice,
            ...payload
          };
        } else {
          return invoice;
        }
      })
    });

    const updatedInvoiceItem = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_invoice_item',
      ...payload,
    });
  },
  async [types.InvoiceItem.DELETE.SINGLE]({ commit, getters }, payload) {
    const invoice_item_id = payload;

    console.log(invoice_item_id);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_items: getters.bookingSettingsData.invoice_items.
        filter(invoice => invoice.invoice_item_id != invoice_item_id)
    });

    const deletedInvoiceItem = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_invoice_item',
      invoice_item_id
    });
  },
  async [types.InvoiceGroupItems.FETCH.ALL]({ commit, getters }, payload) {
    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_group_items: [],
      invoice_group_items_loading: true,
    });

    const group_name = payload;

    invoiceGroupItemsSource && invoiceGroupItemsSource.cancel(REQUEST_CANCELLED);
    invoiceGroupItemsSource = HttpLib.CancelToken.source();

    const invoiceGroupItems = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'get_invoice_group_items',
      output: JSON_STRING,
      group_name,
    }, createHttpGetOptions({
      cancelToken: invoiceGroupItemsSource.token
    }));

    console.log(invoiceGroupItems.data);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      ...invoiceGroupItems.data,
      invoice_group_items_loading: false,
    });
  },
  async [types.InvoiceGroups.INSERT.SINGLE]({ commit, getters }, payload) {
    const group_name = payload;

    console.log(group_name);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_itemgroups: [
        ...getters.bookingSettingsData.invoice_itemgroups,
        { group_name }
      ]
    });

    console.log(getters.bookingSettingsData.invoice_itemgroups);
  },
  async [types.InvoiceGroupItems.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { group_name, invoice_item } = payload;

    const { invoice_item_id } = invoice_item;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_group_items: [
        ...getters.bookingSettingsData.invoice_group_items,
        invoice_item,
      ]
    })

    const newInvoiceItemGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_invoice_itemgroups',
      group_name,
      invoice_item_id,
    });

    // await fetchInvoiceGroupItems(group_name, commit, getters);
    await dispatch(types.InvoiceGroupItems.FETCH.ALL, group_name);
  },
  async [types.InvoiceGroups.DELETE.SINGLE]({ commit, getters }, payload) {
    const { group_name } = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_itemgroups: getters.bookingSettingsData.invoice_itemgroups.
        filter(i => i.group_name != group_name)
    });

    const deletedInvoiceGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'delete_invoice_group',
      group_name
    });
  },
  async [types.InvoiceGroupItems.DELETE.SINGLE]({ commit, getters }, payload) {
    const { invoice_item_group_id } = payload;

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      invoice_group_items: getters.bookingSettingsData.invoice_group_items.
        filter(i => i.invoice_item_group_id != invoice_item_group_id)
    });

    const deletedInvoiceGroupItem = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_invoice_group_item',
      invoice_item_group_id
    });
  },

  async [types.RssList.FETCH.SINGLE]({ commit, getters }, artist_id) {
    const rssFile = await BookingSettingsService.getRssData(artist_id)
    let url = "https://api.rss2json.com/v1/api.json?rss_url=http://detailseu.s3.amazonaws.com/rss/" + rssFile.data.file
    const rssJson = await BookingSettingsService.getRssJson(url)
    // console.log("RSS FILE",rssJson)

    commit(types.RssList.SET.ALL, getters.rssList.map(e => {
      if (e.artist_id == artist_id) {
        return {
          ...e,
          artist_id: artist_id,
          ...rssJson.data,
        };
      } else {
        return e;
      }
    })
    )
  },
  async [types.DEFAULT_LOCK_JSON.UPDATE.SINGLE]({ commit, getters }, payload) {
    // console.log(payload);
    const { key, value } = payload;

    const updated = await HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'update_calendar_dates_lock_json_default',
      key,
      value
    });
  
    // console.log('mdsir: ', updated.data.calendar_dates_lock_json_default);

    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      calendar_dates_lock_json_default: updated.data.calendar_dates_lock_json_default,
    });
  },
  async [types.BookingSettingsData.UPDATE.MULTIPLE]({ commit, getters }, payload) {
    commit(types.BookingSettingsData.SET.ALL, {
      ...getters.bookingSettingsData,
      ...payload
    });
  },
  async [types.TaskTemplate.INSERT.SINGLE]({ dispatch }, payload) {
    const newInvoiceItem = await BookingSettingsService.addUpdateBookingTaskTemplate(payload);
    dispatch(types.TaskTemplate.UPDATE.MULTIPLE);
  },

  //Reload the Task tab data.
  async [types.TaskTemplate.UPDATE.MULTIPLE]({ dispatch }) {
    const taskTab = await BookingSettingsService.findBookingTaskSettingsVal();
    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE, {
      ...taskTab.data
    });
  },
  async [types.TaskTemplate.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const task_template_id = payload;

    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE, {
      task_templates: getters.bookingSettingsData.task_templates.filter(r => r.task_template_id != task_template_id)
    });
    
    await BookingSettingsService.deleteBookingTaskTemplate(task_template_id);
  },
  async [types.TaskTemplateGroup.FETCH.ALL]({ dispatch }, payload) {
    const task_group_id = payload;

    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE,{
      task_templates_of_group_loading: true,
      task_templates_of_group: []
    });

    const taskTemplatesRes = await BookingSettingsService.getTaskTemplatesOfGroup(task_group_id);

    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE, {
      ...taskTemplatesRes.data,
      task_templates_of_group_loading: false
    });
  },
  async [types.TaskTemplateGroup.INSERT.SINGLE]({ dispatch }, payload) {
    const taskTemplatesRes = await BookingSettingsService.addUpdateBookingTaskTemplateGroup({task_group_name:payload});
    dispatch(types.TaskTemplate.UPDATE.MULTIPLE);
  },
  async [types.TaskTemplateGroup.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const { name, value, item: { task_group_id } } = payload;
    // console.log("mdsir:", payload);
    if(value.trim().length < 1){
      return;
    }    
    const up = await BookingSettingsService.addUpdateBookingTaskTemplateGroup({task_group_id, task_group_name: value});
  },
  async [types.TaskTemplateGroup.DELETE.SINGLE]({ dispatch, getters }, payload) {
    const { task_group_id } = payload;

    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE, {
      task_template_groups: getters.bookingSettingsData.task_template_groups.filter(i => i.task_group_id != task_group_id)
    });
    const taskTemplatesRes = await BookingSettingsService.deleteBookingTaskTemplateGroup(task_group_id);
    dispatch(types.TaskTemplate.UPDATE.MULTIPLE);
  },
  async [types.TaskTemplateGroupItems.INSERT.SINGLE]({ dispatch, getters }, payload) {
    const { task_group_id, task_template_id } = payload;

    // Check if already added.
    if(getters.bookingSettingsData.task_templates_of_group.filter(i => i.task_template_id == task_template_id).length > 0){
      return;
    }

    const taskTemplatesRes = await BookingSettingsService.addTaskToTaskTemplateGroup({ task_group_id, task_template_id });
    dispatch(types.TaskTemplateGroup.FETCH.ALL, task_group_id);
    dispatch(types.TaskTemplate.UPDATE.MULTIPLE);
  },
  async [types.TaskTemplateGroupItems.DELETE.SINGLE]({ dispatch, getters }, payload) {
    const { task_group_id, task_template_id } = payload;
    
    dispatch(types.BookingSettingsData.UPDATE.MULTIPLE, {
      task_templates_of_group: getters.bookingSettingsData.task_templates_of_group.filter(i => i.task_template_id != task_template_id)
    });

    const taskTemplatesRes = await BookingSettingsService.removeTaskFromTaskTemplateGroup({ task_group_id, task_template_id });
    // dispatch(types.TaskTemplateGroup.FETCH.ALL, task_group_id);
    dispatch(types.TaskTemplate.UPDATE.MULTIPLE);
  },
}
